import React, { ReactChild } from 'react'
import * as styles from './index.scss'
export { default as Hero } from './Hero'
export { default as Year } from './Year'

interface Props {
  title: string | string[] | ReactChild
  type?: 4 | 5
  leftTabs?: any[]
  rightTabs?: any[]
  index?: number
  typeIndex?: number
  tabChange?: (pos: 0 | 1, idx: number, event) => any
  loading?: boolean
  noheader?: boolean
  notitle?: boolean
}

const CateLayout: React.SFC<Props> = ({
  children,
  title,
  type = 5,
  leftTabs,
  rightTabs,
  index,
  typeIndex,
  tabChange,
  loading,
  noheader,
  notitle,
}) => {
  const tabClick = (pos, idx) => e => tabChange(pos, idx, e)
  const headerRender = (
    <div
      className={styles.categoryHeader}
      style={{
        borderColor: !leftTabs && !rightTabs && 'transparent',
      }}
    >
      <div className={styles.categoryHeaderInner}>
        {!notitle && (
          <div
            className={styles.categoryHeaderTitle}
            style={{
              marginBottom: !leftTabs && !rightTabs && 0,
            }}
          >
            {title}
          </div>
        )}
        <div className={styles.categoryHeaderGroup}>
          <div>
            {leftTabs &&
              leftTabs.map((v, i) => (
                <span
                  className={
                    index === i
                      ? styles.categoryHeaderGroupItemLight
                      : styles.categoryHeaderGroupItem
                  }
                  key={i}
                  onClick={tabClick(0, i)}
                >
                  {v}
                </span>
              ))}
          </div>
          <div>
            {rightTabs &&
              rightTabs.map((v, i) => (
                <span
                  className={
                    typeIndex === i
                      ? styles.categoryTabsItemLight
                      : styles.categoryTabsItem
                  }
                  key={i}
                  onClick={tabClick(1, i)}
                >
                  {v}
                </span>
              ))}
          </div>
        </div>
      </div>
    </div>
  )

  const item = (com, key) => (
    <div
      key={key}
      className={type === 4 ? styles.categoryItem4 : styles.categoryItem5}
    >
      {com}
    </div>
  )

  return (
    <section className={styles.category}>
      {!noheader && headerRender}
      <div className="categoryInner">
        <div
          className={styles.categoryBody}
          style={{
            paddingTop: noheader && 0,
          }}
        >
          {loading ? (
            <div className={styles.nodata}>努力加载中...</div>
          ) : [].concat(children).length ? (
            [].concat(children).map((com, idx) => item(com, idx))
          ) : (
            <div className={styles.nodata}>暂时什么都没有喔</div>
          )}
        </div>
      </div>
    </section>
  )
}

export default CateLayout
